import { render, staticRenderFns } from "./PricingJewellersBlockPrimaryLayer.vue?vue&type=template&id=7d908e43"
import script from "./PricingJewellersBlockPrimaryLayer.vue?vue&type=script&lang=js"
export * from "./PricingJewellersBlockPrimaryLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports